import { render } from "./WorkplaceAnimation.vue?vue&type=template&id=5e4a1474&scoped=true"
import script from "./WorkplaceAnimation.vue?vue&type=script&lang=js"
export * from "./WorkplaceAnimation.vue?vue&type=script&lang=js"

import "./WorkplaceAnimation.vue?vue&type=style&index=0&id=5e4a1474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4a1474"]])

export default __exports__